/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 * Generates the theme object for the component from the theme and provided additional information
 * @param  {Object} theme The actual theme object.
 * @return {Object} The final theme object with the overrides and component variables
 */
const generateComponentTheme = theme => {
  var _colors$contrasts, _colors$contrasts2, _colors$contrasts3, _colors$contrasts4, _colors$contrasts5, _colors$contrasts6, _colors$contrasts7;
  const typography = theme.typography,
    colors = theme.colors,
    spacing = theme.spacing,
    borders = theme.borders,
    themeName = theme.key;
  const themeSpecificStyle = {
    canvas: {
      primaryColor: theme['ic-brand-font-color-dark']
    }
  };
  const componentVariables = {
    ...typography,
    lineHeight: typography === null || typography === void 0 ? void 0 : typography.lineHeightCondensed,
    h1FontSize: typography === null || typography === void 0 ? void 0 : typography.fontSizeXXLarge,
    h1FontWeight: typography === null || typography === void 0 ? void 0 : typography.fontWeightBold,
    h1FontFamily: typography === null || typography === void 0 ? void 0 : typography.fontFamily,
    h2FontSize: typography === null || typography === void 0 ? void 0 : typography.fontSizeXLarge,
    h2FontWeight: typography === null || typography === void 0 ? void 0 : typography.fontWeightNormal,
    h2FontFamily: typography === null || typography === void 0 ? void 0 : typography.fontFamily,
    h3FontSize: typography === null || typography === void 0 ? void 0 : typography.fontSizeLarge,
    h3FontWeight: typography === null || typography === void 0 ? void 0 : typography.fontWeightBold,
    h3FontFamily: typography === null || typography === void 0 ? void 0 : typography.fontFamily,
    h4FontSize: typography === null || typography === void 0 ? void 0 : typography.fontSizeMedium,
    h4FontWeight: typography === null || typography === void 0 ? void 0 : typography.fontWeightBold,
    h4FontFamily: typography === null || typography === void 0 ? void 0 : typography.fontFamily,
    h5FontSize: typography === null || typography === void 0 ? void 0 : typography.fontSizeSmall,
    h5FontWeight: typography === null || typography === void 0 ? void 0 : typography.fontWeightNormal,
    h5FontFamily: typography === null || typography === void 0 ? void 0 : typography.fontFamily,
    h6FontSize: typography === null || typography === void 0 ? void 0 : typography.fontSizeXSmall,
    h6FontWeight: typography === null || typography === void 0 ? void 0 : typography.fontWeightNormal,
    h6FontFamily: typography === null || typography === void 0 ? void 0 : typography.fontFamily,
    primaryInverseColor: colors === null || colors === void 0 ? void 0 : (_colors$contrasts = colors.contrasts) === null || _colors$contrasts === void 0 ? void 0 : _colors$contrasts.white1010,
    primaryColor: colors === null || colors === void 0 ? void 0 : (_colors$contrasts2 = colors.contrasts) === null || _colors$contrasts2 === void 0 ? void 0 : _colors$contrasts2.grey125125,
    secondaryColor: colors === null || colors === void 0 ? void 0 : (_colors$contrasts3 = colors.contrasts) === null || _colors$contrasts3 === void 0 ? void 0 : _colors$contrasts3.grey4570,
    secondaryInverseColor: colors === null || colors === void 0 ? void 0 : (_colors$contrasts4 = colors.contrasts) === null || _colors$contrasts4 === void 0 ? void 0 : _colors$contrasts4.grey1111,
    borderPadding: spacing === null || spacing === void 0 ? void 0 : spacing.xxxSmall,
    borderColor: colors === null || colors === void 0 ? void 0 : (_colors$contrasts5 = colors.contrasts) === null || _colors$contrasts5 === void 0 ? void 0 : _colors$contrasts5.grey1424,
    borderWidth: borders === null || borders === void 0 ? void 0 : borders.widthSmall,
    borderStyle: borders === null || borders === void 0 ? void 0 : borders.style,
    aiTextTopGradientColor: colors === null || colors === void 0 ? void 0 : (_colors$contrasts6 = colors.contrasts) === null || _colors$contrasts6 === void 0 ? void 0 : _colors$contrasts6.violet4570,
    aiTextBottomGradientColor: colors === null || colors === void 0 ? void 0 : (_colors$contrasts7 = colors.contrasts) === null || _colors$contrasts7 === void 0 ? void 0 : _colors$contrasts7.sea4570
  };
  return {
    ...componentVariables,
    ...themeSpecificStyle[themeName]
  };
};
export default generateComponentTheme;